<div class="card shadow-sm">
  <div class="card-body">

    <h4 class="mb-3">
      Lesson properties
      <span class="badge bg-secondary ms-2">
        Current version: v{{ lessonVersion }}
      </span>
    </h4>

    <form [formGroup]="lessonForm">

      <!-- Lesson Title -->
      <div class="mb-3">
        <div class="col-md-6">
          <label class="form-label">Lesson Title</label>
          <input type="text" class="form-control" formControlName="lessonTitle">
        </div>
        <!-- Lesson Subject -->
        <div class="col-md-6">
          <label class="form-label">Lesson Subject</label>
          <input type="text" class="form-control" formControlName="lessonSubject">
        </div>

      </div>

      <!-- Generation Instructions -->
      <div class="mb-4">
        <label class="form-label">Generation Instructions to AI generator</label>
        <textarea class="form-control" maxlength="1000" rows="4" formControlName="lessonInstructions">
      </textarea>
        <small class="text-muted">Max 1000 characters</small>
      </div>

      <!-- Lesson Type -->
      <div class="row g-3">
        <div class="col-lg-4 col-md-6">
          <label class="form-label">Lesson content mode *</label>
          <select class="form-select" formControlName="lessonContentMode">
            <option value="generic">Generic lesson</option>
            <option value="document_reference">Lesson referring to document</option>
            <option value="document_strict">Document-specific lesson</option>
          </select>
          <small class="text-muted d-block">Document-specific: figures cropped from primary reference PDF (no AI images).</small>
        </div>

        <!-- Subject category -->
        <div class="col-lg-4 col-md-6">
          <label class="form-label">Subject category *</label>
          <select class="form-select" formControlName="lessonType">
            <option value="">Select</option>
            <option value="technical">Technical</option>
            <option value="management">Management</option>
            <option value="software">Software Usage</option>
            <option value="others">Others</option>
          </select>
        </div>

        <!-- Approx Slide Count -->
        <div class="col-lg-4 col-md-6">
          <label class="form-label">Approx Slide Count (e.g 0-10, 10-20 etc)"</label>
          <input type="text" class="form-control" formControlName="lessonSlideCount">
        </div>

        <!-- Learner Background -->
        <div class="col-lg-4 col-md-6">
          <label class="form-label">Learner Profile</label>
          <select class="form-select" formControlName="lessonLearnerProfile">
            <option value="">Select</option>
            <option value="newJoinee">New joinee</option>
            <option value="experiencedProfessional">Experienced professional</option>
            <option value="experiencedButNewToSubject">Experienced but new to subject</option>
            <option value="mixed">Mixed</option>
          </select>
        </div>

        <!-- Narration Style -->
        <div class="col-lg-4 col-md-6">
          <label class="form-label">Narration Style</label>
          <select class="form-select" formControlName="lessonStyle">
            <option value="">Select</option>
            <option value="simple">Simple</option>
            <option value="casual">Casual</option>
            <option value="serious">Serious</option>
            <option value="dialoguing">Dialoguing</option>
          </select>
        </div>
      </div>

      <!-- General Expectations -->
      <hr class="my-4">

      <h6 class="mb-3">General Expectations</h6>

      <div class="row g-3" formGroupName="preferences">

        <div class="col-lg-4 col-md-6" *ngFor="let field of generalexpectationfields">

          <label class="form-label">{{ field.label }}</label>

          <select class="form-select" [formControlName]="field.key">
            <option value="NA">NA</option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </select>
        </div>
      </div>

      <div class="row g-2 mb-3" formGroupName="preferences" *ngIf="isAssessmentEnabled()">
        <div class="col-12">
          <label class="form-label fw-semibold">Assessment / quiz counts</label>
          <p class="small text-muted mb-2">Stored with the lesson and used when generating TOC and quiz questions.</p>
        </div>
        <div class="col-md-6">
          <label class="form-label">Questions per section (0–3)</label>
          <input type="number" class="form-control" formControlName="lessonQuizPerSection" min="0" max="3" />
        </div>
        <div class="col-md-6">
          <label class="form-label">End-of-lesson quiz (0–20)</label>
          <input type="number" class="form-control" formControlName="lessonQuizEndCount" min="0" max="20" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Simple (end quiz mix)</label>
          <input type="number" class="form-control" formControlName="lessonQuizSimpleCount" min="0" max="20" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Complex (end quiz mix)</label>
          <input type="number" class="form-control" formControlName="lessonQuizComplexCount" min="0" max="20" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Applied (end quiz mix)</label>
          <input type="number" class="form-control" formControlName="lessonQuizAppliedFinalCount" min="0" max="20" />
        </div>
      </div>


      <!-- Technical-only -->
      <div *ngIf="isTechnical()">
        <hr class="my-4">
        <h6 class="mb-3">Technical Specific Instructions</h6>


        <div class="row g-3" formGroupName="techpreferences">


          <div class="col-lg-4 col-md-6" *ngFor="let fieldt of technicalexpectationfields">

            <label class="form-label">{{ fieldt.label }}</label>

            <select class="form-select" [formControlName]="fieldt.key">
              <option value="NA">NA</option>
              <option value="Y">Yes</option>
              <option value="N">No</option>
            </select>
          </div>

        </div>
      </div>

      <!-- Reference files -->
      <hr class="my-4" *ngIf="canManageReferences()">
      <div class="mb-4" *ngIf="canManageReferences()">
        <h6 class="mb-2">Reference files</h6>
        <p class="small text-muted mb-3">
          The lesson can be based on file(s) that you upload (PDF or images). These files are used when generating the
          TOC and slide content — they are not shown on slides directly.
          If you want the lesson built <strong>strictly</strong> from an uploaded file (with source page references in the
          TOC), set <strong>Primary Reference</strong> to <strong>Yes</strong> for that file.
          You may upload multiple files (max {{ refMaxMbLabel }} each).
        </p>

        <div *ngIf="referencesLocked()" class="alert alert-secondary py-2 small mb-3">
          Reference files are locked after slides are generated. Clear lesson content to change files.
        </div>
        <div *ngIf="hasExpiredOpenAiReferences()" class="alert alert-warning py-2 small mb-3">
          OpenAI upload expired for: {{ expiredOpenAiReferenceNames() }}.
          Refresh before generating TOC or slides in chat (local files are kept; only the OpenAI copy is renewed).
          <div class="mt-2">
            <button
              type="button"
              class="btn btn-sm btn-warning"
              (click)="refreshExpiredOpenAiUploads()"
              [disabled]="refRefreshOpenAiBusy || refUploading || contentActionBusy"
            >
              {{ refRefreshOpenAiBusy ? 'Refreshing…' : 'Refresh OpenAI upload' }}
            </button>
          </div>
        </div>

        <h6 class="small text-muted mb-2">
          Uploaded files
          <span *ngIf="references.length">({{ references.length }})</span>
        </h6>
        <table class="table table-sm table-bordered mb-3" *ngIf="references.length; else noRefs">
          <thead class="table-light">
            <tr>
              <th>File</th>
              <th>Primary Reference?</th>
              <th>TOC</th>
              <th>Slides</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ref of references" [class.table-warning]="isReferenceOpenAiExpired(ref)">
              <td>
                <span>{{ ref.label || ref.fileName }}</span>
                <span class="text-muted small d-block">{{ formatRefSize(ref.fileSizeBytes) }}</span>
                <span *ngIf="isReferenceOpenAiExpired(ref)" class="badge text-bg-warning">OpenAI expired</span>
              </td>
              <td>
                <select
                  class="form-select form-select-sm"
                  [ngModel]="primaryReferenceYn(ref)"
                  (ngModelChange)="setPrimaryReference(ref, $event)"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="referencesLocked()"
                >
                  <option value="N">No</option>
                  <option value="Y">Yes</option>
                </select>
              </td>
              <td class="text-center">
                <input
                  type="checkbox"
                  [checked]="ref.useForToc === 'Y'"
                  [disabled]="referencesLocked()"
                  (change)="toggleReferenceFlag(ref, 'useForToc', $event)"
                />
              </td>
              <td class="text-center">
                <input
                  type="checkbox"
                  [checked]="ref.useForSlides === 'Y'"
                  [disabled]="referencesLocked()"
                  (change)="toggleReferenceFlag(ref, 'useForSlides', $event)"
                />
              </td>
              <td>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  *ngIf="!referencesLocked()"
                  (click)="deleteReference(ref.refId)"
                >
                  Remove
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #noRefs>
          <p class="text-muted small mb-3">No reference files uploaded yet.</p>
        </ng-template>

        <div class="row g-2 align-items-end" *ngIf="!referencesLocked()">
          <div class="col-md-3">
            <label class="form-label">Primary Reference?</label>
            <select
              class="form-select form-select-sm"
              [(ngModel)]="refUploadPrimary"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="refUploading"
            >
              <option value="N">No</option>
              <option value="Y">Yes</option>
            </select>
            <div class="form-text">Applies to the next file(s) you add.</div>
          </div>
          <div class="col-md-9">
            <label class="form-label">Add file(s)</label>
            <input
              type="file"
              class="form-control form-control-sm"
              accept=".pdf,image/png,image/jpeg,image/gif,image/webp"
              multiple
              [disabled]="refUploading"
              (change)="onReferenceFilesSelected($event)"
            />
            <div class="form-text">Select one or more PDF/image files (max {{ refMaxMbLabel }} each).</div>
          </div>
        </div>
        <div *ngIf="refUploadStatus" class="text-primary small mt-2" role="status">{{ refUploadStatus }}</div>
        <div *ngIf="refUploadError" class="text-danger small mt-2" style="white-space: pre-line">{{ refUploadError }}</div>
      </div>

      <!-- Slide image assets ZIP (edit only) -->
      <div class="mb-4 border rounded p-3" *ngIf="isEdit && lessonId">
        <h5 class="mb-2">Slide image assets (ZIP)</h5>
        <p class="small text-muted mb-2">
          Upload or download images for this lesson (<code>lessonId {{ lessonId }}</code>).
          ZIP layout is <code>&lt;slideId&gt;/&lt;imageFileName&gt;</code>
          (e.g. <code>SL_intro_01/diagram.png</code>) so you can edit offline and re-upload.
          Slide folders are created if missing; existing files prompt for overwrite.
        </p>
        <div class="d-flex flex-wrap gap-2 align-items-center">
          <label class="btn btn-sm btn-outline-primary mb-0" [class.disabled]="assetsZipUploading || assetsZipDownloading">
            {{ assetsZipUploading ? 'Extracting…' : 'Upload slide images ZIP' }}
            <input
              type="file"
              accept=".zip,application/zip"
              hidden
              (change)="onLessonAssetsZipSelected($event)"
              [disabled]="assetsZipUploading || assetsZipDownloading" />
          </label>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            (click)="downloadLessonAssetsZip()"
            [disabled]="assetsZipUploading || assetsZipDownloading">
            {{ assetsZipDownloading ? 'Preparing ZIP…' : 'Download slide images ZIP' }}
          </button>
          <span class="text-muted small" *ngIf="assetsZipFileName">{{ assetsZipFileName }}</span>
        </div>
        <div *ngIf="assetsZipStatus" class="text-primary small mt-2">{{ assetsZipStatus }}</div>
        <div *ngIf="assetsZipError" class="text-danger small mt-2" style="white-space: pre-line">{{ assetsZipError }}</div>
      </div>

      <!-- Actions -->
      <div class="alert alert-warning py-2" *ngIf="!isEdit && licenseStatus && !canCreateLesson()">
        {{ licenseStatus.message || 'No licenses available. Contact your administrator.' }}
      </div>
      <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-4">
        <div class="d-flex flex-wrap gap-2">
          <button class="btn btn-primary" (click)="save()" [disabled]="lessonForm.invalid || contentActionBusy || (!isEdit && !canCreateLesson())">
            Save
          </button>
          <button class="btn btn-success" *ngIf="isEdit && (lessonStatus == 'EMPTY' || lessonStatus == 'TOC')" (click)="proceedToTOC()" [disabled]="contentActionBusy">
            Proceed to TOC
          </button>
        </div>
        <div class="d-flex flex-wrap gap-2" *ngIf="isEdit">
          <button
            type="button"
            class="btn btn-outline-warning"
            *ngIf="canClearLessonContent()"
            (click)="clearLessonContent()"
            [disabled]="contentActionBusy"
          >
            Clear and Recreate TOC
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            *ngIf="!linkedToProject"
            (click)="deleteLesson()"
            [disabled]="contentActionBusy"
          >
            Delete lesson
          </button>
        </div>
        <button class="btn btn-secondary" (click)="backToDashboard()" [disabled]="contentActionBusy">
          Back to Dashboard
        </button>
      </div>

    </form>
  </div>
</div>
